/* eslint-disable no-nested-ternary */
import React from 'react';
import { Box } from '@mui/material';

import { NoAccess, IconButtonV2 } from 'components/common/ui';
import { PermissionsGate, FavoriteDashboard } from '@components';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';

import styles from './pageDatesLayout.style';

const PageDatesLayout = ({
  renderHeaderOptions,
  children,
  entity,
  disablePermissionGate,
  title,
  onToday,
  onFrontButon,
  onBackButton,
}) => {
  return (
    <PermissionsGate
      entity={entity}
      RenderError={NoAccess}
      disabled={disablePermissionGate}
    >
      <Box>
        <Box sx={styles.header}>
          <Box sx={styles.title}>
            <FavoriteDashboard style={{ mr: '-12px' }} />
            <Box sx={styles.titleText}>{title}</Box>
            <Box sx={styles.arrows}>
              {onBackButton && (
                <IconButtonV2
                  variant="text"
                  color="blues"
                  onClick={onBackButton}
                >
                  <ChevronLeftRoundedIcon data-testid="ChevronLeftRoundedIcon" />
                </IconButtonV2>
              )}
              {onFrontButon && (
                <IconButtonV2
                  variant="text"
                  color="blues"
                  onClick={onFrontButon}
                >
                  <ChevronRightRoundedIcon data-testid="ChevronRightRoundedIcon" />
                </IconButtonV2>
              )}
            </Box>
            {onToday && (
              <Box sx={styles.today} onClick={onToday}>
                Today
              </Box>
            )}
          </Box>
          <Box sx={styles.headerOptions}>
            {renderHeaderOptions && renderHeaderOptions()}
          </Box>
        </Box>

        <Box>{children}</Box>
      </Box>
    </PermissionsGate>
  );
};

export default PageDatesLayout;
